export default __webpack_public_path__ + "static/media/delete_black.f40424dd.svg";